module.exports = __webpack_public_path__ + "img/927253_EECEA7_D8B792_C7A883-256px.05e2056a.png";